import React, { useState, useEffect } from "react";
import { Table, Icon, Input, Message, Button } from "semantic-ui-react";
import { map } from "lodash";
import { useNavigate } from "react-router-dom";

export function TablePracticantesDisponibles({
  cursosTitulacion,
  dataDocente,
}) {
  const itemsPerPage = 9;
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [grupoSearch, setGrupoSearch] = useState("");
  const [materiaSearch, setMateriaSearch] = useState("");

  const handleGrupoSearchChange = (value) => {
    setGrupoSearch(value.toLowerCase());
    setCurrentPage(1);
  };

  const handleMateriaSearchChange = (value) => {
    setMateriaSearch(value.toLowerCase());
    setCurrentPage(1);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const filteredCursos = cursosTitulacion.filter(
    (curso) =>
      curso.materia_data.nombre_materia.toLowerCase().includes(materiaSearch) &&
      curso.grupo_data.numero_grupo
        .toString()
        .toLowerCase()
        .includes(grupoSearch)
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [materiaSearch, grupoSearch]);

  useEffect(() => {
    const lastPage = Math.ceil(filteredCursos.length / itemsPerPage);
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
  }, [filteredCursos, currentPage]);

  const sortedCursos = filteredCursos.sort((cursoA, cursoB) => {
    const grupoA = cursoA.grupo_data.numero_grupo;
    const grupoB = cursoB.grupo_data.numero_grupo;
    return grupoA - grupoB;
  });

  const paginatedCursos = sortedCursos.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const formatPeriodo = (fecha) => {
    const opciones = { month: "long", year: "numeric" };
    const fechaFormateada = new Date(fecha).toLocaleDateString(
      "es-ES",
      opciones
    );
    return fechaFormateada.charAt(0).toUpperCase() + fechaFormateada.slice(1);
  };

  return (
    <div>
      <div className="buscar">
        <Icon name="search" className="bot" />
        <Input
          placeholder="Buscar por materia"
          value={materiaSearch}
          onChange={(e) => handleMateriaSearchChange(e.target.value)}
          style={{ marginTop: "20px", marginRight: "10px" }}
        />
        <Icon name="search" className="bot" />
        <Input
          placeholder="Buscar por grupos"
          value={grupoSearch}
          onChange={(e) => handleGrupoSearchChange(e.target.value)}
          style={{ marginTop: "20px" }}
        />
      </div>
      <div>
        {filteredCursos.length > 0 ? (
          <Table className="table-users-admin">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>PERIODO</Table.HeaderCell>
                <Table.HeaderCell>CLAVE</Table.HeaderCell>
                <Table.HeaderCell>MATERIA</Table.HeaderCell>
                <Table.HeaderCell>GRUPO</Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {map(paginatedCursos, (curso, index) => (
                <Table.Row key={index}>
                  <Table.Cell>{`${formatPeriodo(
                    curso.periodo_data.fecha_inicio
                  )} - ${formatPeriodo(
                    curso.periodo_data.fecha_fin
                  )}`}</Table.Cell>{" "}
                  <Table.Cell>{curso.materia_data.clave_materia}</Table.Cell>
                  <Table.Cell>
                    {curso.materia_data.nombre_materia.toLowerCase()}
                  </Table.Cell>
                  <Table.Cell>{curso.grupo_data.numero_grupo}</Table.Cell>
                  <Table.Cell>
                    <Button
                      className="botonEnviar"
                      onClick={() =>
                        navigate(`/gestion-docente/practicantes-disponibles/`, {
                          state: { curso, dataDocente },
                        })
                      }
                    >
                      Ir al grupo
                    </Button>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        ) : (
          <Message
            info
            header="No hay grupos de practicantes disponibles para este periodo"
            content="Selecciona un periodo diferente para ver otros grupos de practicantes."
          />
        )}
      </div>
      <div style={{ textAlign: "center", marginTop: "10px" }}>
        <Button.Group>
          {Array.from({
            length: Math.ceil(filteredCursos.length / itemsPerPage),
          }).map((_, index) => {
            const pageNumber = index + 1;
            const maxVisibleButtons = 4;
            const startPage = Math.max(
              1,
              currentPage - Math.floor(maxVisibleButtons / 2)
            );
            const endPage = Math.min(
              startPage + maxVisibleButtons - 1,
              Math.ceil(filteredCursos.length / itemsPerPage)
            );
            const showStartEllipsis = startPage > 1;
            const showEndEllipsis =
              endPage < Math.ceil(filteredCursos.length / itemsPerPage);

            if (Math.ceil(filteredCursos.length / itemsPerPage) === 1) {
              return null;
            }
            if (pageNumber >= startPage && pageNumber <= endPage) {
              return (
                <Button
                  key={pageNumber}
                  icon
                  active={currentPage === pageNumber}
                  onClick={() => handlePageChange(pageNumber)}
                >
                  {pageNumber}
                </Button>
              );
            } else if (showStartEllipsis && pageNumber === 1) {
              return (
                <Button key="startEllipsis" icon className="bordebotn">
                  {"..."}
                </Button>
              );
            } else if (
              showEndEllipsis &&
              pageNumber === Math.ceil(filteredCursos.length / itemsPerPage)
            ) {
              return (
                <Button key="endEllipsis" icon className="bordebotn">
                  {"..."}
                </Button>
              );
            }
            return null;
          })}
        </Button.Group>
      </div>
    </div>
  );
}
